<template>
  <div class="calendar-invite">
    <div v-if="sharing" class="inline-page" />
    <weui-radio-group
      title="请选择为哪一天发起约课邀请"
      :options="date_options"
      v-model="selected_date"
    />
    <weui-button-area>
      <weui-button type="default" @click="invite">发出邀请</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiRadioGroup, WeuiButtonArea, WeuiButton } from '@/components/weui';
import { MENU_ITEM_SHARE_APP_MESSAGE, MENU_ITEM_SHARE_TIMELINE } from '@/constants/jssdk';
import { FETCH_AVAILABLE_DATES } from '@/store/coach/types';
import { SHARE_INVITE } from '@/store/share/types';
import mixinFormatters from '@/mixins/formatters';
import datetimeUtils from '@/utils/datetime';

const { mapState: mapCoachState, mapActions: mapCoachActions } = createNamespacedHelpers('coach');
const { mapState: mapShareState, mapActions: mapShareActions } = createNamespacedHelpers('share');

export default {
    data() {
        return {
            sharing: false,
            selected_date: datetimeUtils.getToday(true),
        };
    },
    computed: {
        ...mapCoachState({
            available_dates: state => state.available_dates || [],
        }),
        ...mapShareState({
            share: state => state.share || {},
        }),
        date_options() {
            return this.available_dates
                .slice(0, 3)
                .map((d, idx) => ({
                    value: d.date,
                    text: `${this.formatDate(d.date)}（已有${d.course_count}节）`,
                    checked: idx === 0,
                }));
        },
    },
    created() {
        this.fetchAvailableDates({ date: 'today' });
    },
    methods: {
        ...mapCoachActions({
            fetchAvailableDates: FETCH_AVAILABLE_DATES,
        }),
        ...mapShareActions({
            shareInvite: SHARE_INVITE,
        }),
        invite() {
            this.shareInvite({ date: this.selected_date })
                .then(() => {
                    this.$wechat.shareTimeline(this.share);
                    this.$wechat.showMenuItem(MENU_ITEM_SHARE_TIMELINE);
                    this.$wechat.shareAppMessage(this.share);
                    this.$wechat.showMenuItem(MENU_ITEM_SHARE_APP_MESSAGE);
                    this.sharing = true;
                });
        },
    },
    mixins: [
        mixinFormatters,
    ],
    components: {
        WeuiRadioGroup,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>

<style lang="scss" scoped>
.inline-page {
    background: rgba(0, 0, 0, 0.85) url(../../assets/images/share-invite.png) no-repeat;
    background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/containers/invite/Index.vue